import 'babel-polyfill'
import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/views/Layout/index'


Vue.use(Router)

//获取原型对象上的push函数,用于解决重复push报错问题
const originalPush = Router.prototype.push
//修改原型对象中的push方法
Router.prototype.push = function push(location) {
   return originalPush.call(this, location).catch(err => err)
}
export default new Router({
  scrollBehavior: () => ({y: 0}),
  // mode:'history',
  base: '/pepco/',
  routes:[ 
    {
    path:'/index',
    component:()=>import('@/views/index/index.vue'),
    meta: {
      title: '小猪班纳服饰有限公司官网',
    }
    },
    {
      path:'',
      component:()=>import('@/views/index/index.vue'),
      meta: {
        title: '小猪班纳服饰有限公司官网',
      }
    },
    {
      path:'/introduction',
      component:Layout,
      redirect:'/introduction/index',
      children:[
        {
          path:'index',
          name:'introductionIndex',
          component:()=>import('@/views/introduction/index.vue'),
          meta:{title:'公司简介'}
        },
        {
          path:'history',
          name:'history',
          component:()=>import('@/views/introduction/history.vue'),
          meta:{title:'发展历史'}
        },
        {
          path:'distribution',
          name:'distribution',
          component:()=>import('@/views/introduction/distribution.vue'),
          meta:{title:'门店分布'}
        },
        {
          path:'show',
          name:'introductionShow',
          component:()=>import('@/views/introduction/show.vue'),
          meta:{title:'门店展示'}
        }
      ]
      
    },
    {
      path:'/corporateImage',
      component:Layout,
      redirect:'/corporateImage/index',
      children:[
        {
          path:'index',
          name:'corporateImageIndex',
          component:()=>import('@/views/corporateImage/index.vue'),
          meta:{title:'形象大片'}
        },
        {
          path:'show/:id',
          name:'corporateImageShow',
          component:()=>import('@/views/corporateImage/show.vue'),
          meta:{title:'形象展示'}
        }
      ]
    },
    {
      path:'/brandInformation',
      name:'brandInformation',
      redirect:'/brandInformation/index',
      component:Layout,
      children:[
        {
          path:'index',
          name:'brandInformationIndex',
          component:()=>import('@/views/brandInformation/index.vue'),
          meta:{title:'品牌资讯'}
        },
        {
          path:'show/:id',
          name:'brandInformationShow',
          component:()=>import('@/views/brandInformation/show.vue'),
          meta:{title:'资讯详情'}
        }
      ]
    },
    {
      path:'/franchise',
      name:'franchise',
      redirect:'/franchise/index',
      component:Layout,
      children:[
        {
          path:'index',
          name:'franchiseIndex',
          component:()=>import('@/views/franchise/index.vue'),
          meta:{title:'加盟信息'}
        }
      ]
    },
    {
      path:'/ambassador',
      name:'ambassador',
      redirect:'/ambassador/index',
      component:Layout,
      children:[
        {
          path:'index',
          name:'ambassadorIndex',
          component:()=>import('@/views/ambassador/index.vue'),
          meta:{title:'体验官申请'}
        }
      ]
    },
    {
      path:'/apply',
      redirect:'/ambassador/index'
    },
    {
      path:'/vmd/upload',
      name:'vmdUpload',
      component:()=>import('@/views/vmd/upload.vue'),
      meta:{title:'门店图片上传'}
    },
    {
      path:'/vmd/review',
      name:'vmdReview',
      component:()=>import('@/views/vmd/review.vue'),
      meta:{title:'图片点评'}
    },
    {
      path:'/admin',
      name:'admin',
      redirect:'/admin/home',
      component:Layout,
      children:[
        {
          path:'login',
          name:'login',
          component:()=>import('@/views/admin/login.vue'),
          meta:{title:'官网后台管理登录'}
        },
        {
          path:'',
          component:()=>import('@/views/Layout/admin.vue'),
          children:[
            {
              path:'home',
              name:'ahome',
              component:()=>import('@/views/admin/home.vue'),
              meta:{title:"首页"}
            },
            {
              path:'franchise',
              name:'afranchise',
              component:()=>import('@/views/admin/franchise.vue'),
              meta:{title:"加盟信息"}
            },
            {
              path:'ambassador',
              name:'aambassador',
              component:()=>import('@/views/admin/ambassador-manage.vue'),
              meta:{title:"体验官申请"}
            },
            {
              path:'brandInformation/:id',
              name:'abrandInformation',
              component:()=>import('@/views/admin/brandInformation/brandInformation.vue'),
              meta:{title:"品牌资讯-修改"}
            },
            {
              path:'brandInformation',
              name:'abrandInformation_new',
              component:()=>import('@/views/admin/brandInformation/brandInformation.vue'),
              meta:{title:"品牌资讯-新增"}
            },
            {
              path:'brandInformationList',
              name:'abrandInformationList',
              component:()=>import('@/views/admin/brandInformation/brandInformationList.vue'),
              meta:{title:"品牌资讯列表"}
            },
            {
              path:'imageSort',
              name:'imageSort',
              component:()=>import('@/views/admin/corporateImage/sort.vue'),
              meta:{title:"形象分类"}
            },
            {
              path:'imageList',
              name:'imageList',
              component:()=>import('@/views/admin/corporateImage/corporateImageList.vue'),
              meta:{title:"形象列表"}
            },
            {
              path:'company',
              name:'company',
              component:()=>import('@/views/admin/introduction/company.vue'),
              meta:{title:"公司介绍"}
            },
            {
              path:'history',
              name:'ahistory',
              component:()=>import('@/views/admin/introduction/history.vue'),
              meta:{title:"发展历史"}
            },
            {
              path:'distribution',
              name:'adistribution',
              component:()=>import('@/views/admin/introduction/distribution.vue'),
              meta:{title:"门店分布"}
            },
            {
              path:'show',
              name:'ashow',
              component:()=>import('@/views/admin/introduction/show.vue'),
              meta:{title:"门店展示"}
            },
            {
              path:'admin',
              name:'admin',
              component:()=>import('@/views/admin/system/admin.vue'),
              meta:{title:"管理员设置"}
            },
            {
              path:'logger',
              name:'logger',
              component:()=>import('@/views/admin/system/optLogger.vue'),
              meta:{title:"管理员操作日志"}
            },
            {
              path:'vmdReview',
              name:'avmdReview',
              component:()=>import('@/views/vmd/review.vue'),
              meta:{title:"图片点评"}
            }
          ]
        },
      ]
    }
    ]  
})
